import { connect } from 'react-redux'
import { addElement } from '../../../../actions/elements_order'
import { initUploader } from '../../../../actions/uploader_actions'

const mapStateToProps = (state: any) => ({
  currentElement: state.elementsOrder?.currentElement,
  currentTemplate: state.elementsOrder?.currentTemplate,
  currentTemplateData: state.elementsOrder?.currentTemplateData,
  currentReplaceElementId: state.elementsOrder?.currentReplaceElementId,
  allowImageUpload: state.elementsOrder.companySettings?.allowImageUpload,
  uploaderOptions: state.elementsOrder?.uploaderOptions,
})

const mapDispatchToProps = {
  addElement,
  initUploader,
}

export default connect(mapStateToProps, mapDispatchToProps)